export const version = 'kunde-v1.20.0-rc49';